import styles from "../portfolio/Portfolio.module.scss";

function Portfolio() {
  return <div className={styles.maincontainer}>portfolio</div>;
}

export default Portfolio;
